import tableVariables from './tableVariables';

export default tableVariables;
